import { fetchWithChatFeedback } from './chatFeedbackRequired';
/**
 * Read-only changelog API client.
 *
 * The backend is responsible for enforcing the changelog entitlement. This
 * client deliberately carries no role logic so RA/CE membership cannot be
 * inferred or bypassed in the browser.
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export interface ChangelogRelease {
  date: string;
  title: string;
  intro?: string;
  markdown: string;
}

export interface ChangelogResponse {
  releases: ChangelogRelease[];
}

export async function fetchChangelog(): Promise<ChangelogResponse> {
  const response = await fetchWithChatFeedback(`${API_BASE_URL}/api/changelog`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Unable to load changelog');
  }

  const data = await response.json();
  if (!Array.isArray(data?.releases)) {
    throw new Error('Invalid changelog response');
  }

  return {
    releases: data.releases.filter(
      (release: unknown): release is ChangelogRelease =>
        typeof release === 'object' &&
        release !== null &&
        typeof (release as ChangelogRelease).date === 'string' &&
        typeof (release as ChangelogRelease).title === 'string' &&
        typeof (release as ChangelogRelease).markdown === 'string'
    ),
  };
}
